export default __webpack_public_path__ + "static/media/pin.ed327b8d.svg";